<div class="lcl-destination-warehouse">
  <div class="lcl-destination-warehouse__hint" *ngIf="shipment?.trackingState === TRACKING_STATES.AT_ORIGIN_WAREHOUSE">
    <span>
      {{ "LCL_SHIPMENT.SHIPMENT.DESTINATION_WAREHOUSE_HINT" | translate }}
    </span>
  </div>

  <div class="row" *ngIf="shipment?.trackingState > TRACKING_STATES.AT_ORIGIN_WAREHOUSE">
    <div class="col-12 lcl-destination-warehouse__address" [ngClass]="{ 'col-xl-4': isHasContactsInfo, 'col-xl-6': !isHasContactsInfo }">
      <span class="lcl-destination-warehouse__address-label">{{ "LABELS.ADDRESS" | translate }}</span>
      <span class="lcl-destination-warehouse__address-info">{{ shipment?.voyage?.destinationContainerFreightStorage?.displayName }}</span>
      <span class="lcl-destination-warehouse__address-info secondary">
        <address-details
          [address]="shipment?.voyage?.destinationContainerFreightStorage?.address"
          *ngIf="!!shipment?.voyage?.destinationContainerFreightStorage?.address"
        ></address-details>
      </span>
    </div>

    <div class="col-12 col-xl-4 lcl-destination-warehouse__contacts" *ngIf="isHasContactsInfo">
      <span class="lcl-destination-warehouse__contacts-label">{{ "LABELS.CONTACT_INFORMATION" | translate }}</span>

      <ng-container *ngIf="!!shipment?.voyage?.destinationContainerFreightStorage?.phoneNumber">
        <span class="lcl-destination-warehouse__contacts-label-secondary">{{ "LABELS.MOBILE_NUMBER" | translate }}</span>
        <span class="lcl-destination-warehouse__hours-info">{{ shipment.voyage?.destinationContainerFreightStorage?.phoneNumber }}</span>
      </ng-container>

      <ng-container *ngIf="!!shipment?.voyage?.destinationContainerFreightStorage?.faxNumber">
        <span class="lcl-destination-warehouse__contacts-label-secondary">{{ "LABELS.FAX" | translate }}</span>
        <span class="lcl-destination-warehouse__hours-info">{{ shipment.voyage?.destinationContainerFreightStorage?.faxNumber }}</span>
      </ng-container>

      <ng-container *ngIf="!!shipment?.voyage?.destinationContainerFreightStorage?.email">
        <span class="lcl-destination-warehouse__contacts-label-secondary">{{ "LABELS.EMAIL_ADDRESS" | translate }}</span>
        <span class="lcl-destination-warehouse__hours-info">{{ shipment.voyage?.destinationContainerFreightStorage?.email }}</span>
      </ng-container>
    </div>

    <div class="col-12 lcl-destination-warehouse__hours" [ngClass]="{ 'col-xl-4': isHasContactsInfo, 'col-xl-6': !isHasContactsInfo }">
      <span class="lcl-destination-warehouse__hours-label">{{ "LABELS.OPENING_HOURS" | translate }}</span>
      <span class="lcl-destination-warehouse__hours-info">{{ shipment?.voyage?.destinationContainerFreightStorage?.openingHours }}</span>
    </div>
  </div>

  <div class="col-12 lcl-destination-warehouse__note" *ngIf="shipment?.trackingState > TRACKING_STATES.AT_ORIGIN_WAREHOUSE && isImporter">
    {{ "LCL_SHIPMENT.SHIPMENT.DESTINATION_WAREHOUSE_NOTE" | translate }}
  </div>
</div>
